var defaultSyntaxes = {
	markup: 'html',
	stylesheet: 'css'
};

var knownSyntaxes = {
	markup: ['html', 'xml', 'xsl', 'jsx', 'js', 'pug', 'slim', 'haml'],
	stylesheet: ['css', 'sass', 'scss', 'less', 'sss', 'stylus']
};

/**
 * Config resolver: returns compiled config that can be used in
 * `@emmetio/expand-abbreviation` module for expanding abbreviations
 * @param {EmmetConfig} config Config object
 * @param {EmmetConfigParams} [params] Additional params like `.syntax` and `.project` for
 * config resolving
 * @returns {Object}
 */
function compileConfig(config, params) {
	params = createParams(config, params || {});

	var resolved = resolveConfig(config, params);

	// Copy extra fields from original config
	var knownFields = ['globals', 'syntax', 'project'];
	for (var p in config) {
		if (knownFields.indexOf(p) === -1) {
			resolved[p] = config[p];
		}
	}

	return resolved;
}

/**
 * Resolves config for markup syntax
 * @param {EmmetConfig} config
 * @param {EmmetConfigParams} params
 * @return {Object}
 */
function resolveConfig(config, ref) {
	var type = ref.type;
	var syntax = ref.syntax;
	var project = ref.project;

	return {
		syntax: syntax,
		type: type,
		project: project,
		format:  mergeConfig(config, 'format', type, syntax, project),
		profile: mergeConfig(config, 'profile', type, syntax, project),
		options: mergeConfig(config, 'options', type, syntax, project),
		variables: mergeConfig(config, 'variables', type, syntax, project),
		snippets: getConfig(config, 'snippets', type, syntax, project).filter(Boolean)
	};
}

/**
 * @param {EmmetConfig} config 
 * @param {EmmetConfigParams} params 
 * @returns {EmmetConfigParams}
 */
function createParams(config, params) {
	var type = params.type;
	var syntax = params.syntax;

	if (!type && !syntax) {
		type = 'markup';
		syntax = defaultSyntaxes[type];
	} else if (!type && syntax) {
		if (knownSyntaxes.markup.indexOf(syntax) !== -1) {
			type = 'markup';
		} else if (knownSyntaxes.stylesheet.indexOf(syntax) !== -1) {
			type = 'stylesheet';
		} else {
			type = get(config, ['syntax', syntax, 'type'])
				|| get(config, ['project', params.project, 'syntax', syntax, 'type']);
		}
	} else if (!syntax) {
		syntax = defaultSyntaxes[type];
	}

	return Object.assign({}, params, {type: type, syntax: syntax});
}

function mergeConfig(config, key, type, syntax, project) {
	return getConfig(config, key, type, syntax, project)
		.reduce(function (out, obj) { return (Object.assign({}, out, obj)); }, {});
}

function getConfig(config, key, type, syntax, project) {
	return [
		get(config, ['globals', type, key]),
		get(config, ['project', project, 'globals', type, key]),
		get(config, ['syntax', syntax, key]),
		get(config, ['project', project, 'syntax', syntax, key])
	].filter(Boolean);
}

/**
 * Safe dot-property getter for `obj`: returns value of `obj` by given `key`,
 * separated by `.`, but doesn’t throw error if any of the property key exists
 * @param {Object} obj
 * @param {String[]} key
 * @param {*} [defaultValue] 
 * @return {*}
 */
function get(obj, key, defaultValue) {
	var result = obj;

	for (var i = 0; i < key.length; i++) {
		if (result == null) {
			break;
		}

		result = result[key[i]];
	}

	return result != null ? result : defaultValue;
}

export default compileConfig;
//# sourceMappingURL=config.es.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@emmetio/config/dist/config.es.js
// module id = null
// module chunks = 